import { render } from "./PrivacyPolicyEs.vue?vue&type=template&id=0edc35ea&scoped=true"
import script from "./PrivacyPolicyEs.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyEs.vue?vue&type=script&lang=js"

import "./PrivacyPolicyEs.vue?vue&type=style&index=0&id=0edc35ea&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0edc35ea"]])

export default __exports__